import { SubscriptionFees } from "@/pages/admin/SubscriptionFees";

export default function FeesPage() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8" data-testid="fees-page">
      <div className="mb-6">
        <div className="text-[10px] tracking-[0.3em] uppercase text-[#83B68B]">Finance</div>
        <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tight mt-1">Subscription Fees & Refunds</h1>
      </div>
      <SubscriptionFees />
    </div>
  );
}
